import { ACTION_TYPES } from '../constants';

export default (path, lang) => ({
  type: ACTION_TYPES.FETCH_REQUEST,
  payload: {
    path,
    lang
  }
});
